module.exports = __webpack_public_path__ + "static/media/kudusong.93f47a24.mp3";